<div class="body-face-capture">
  <div class="media-face-capture">
    @if (!capturedImage) {
      <div class="video-container">
        <video #videoElement autoplay muted playsinline></video>
        <div class="oval-border"></div>
      </div>
    }
    @if (capturedImage) {
      <img [src]="capturedImage" alt="Captured Face" />
    }
  </div>
  <p class="status-face-capture">{{ detectionStatus }}</p>
</div>